import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import {
  isEmptyVal,
  isNotEmpty,
  displayField,
  displayDateTimeField,
  displayDateField,
  formatTimeField,
  processSecond,
} from "../../../utils/helpers";

const CommercialScheduleItemTimeCell = ({
  dataKey,
  rowData,
  onClick,
  ...props
}: {
  dataKey?: string;
  rowData: any;
  onClick?: Function;
  props?: any;
}) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  if (isEmptyVal(rowData?.total_items)) rowData.total_items = 0;
  const speaker = (
    <Popover title={rowData?.schedule_title}>
      <p>
        <b>
          {" "}
          {t("STARTS")} {t("AT")} :{" "}
        </b>
        {formatTimeField(rowData.play_starts_at, "12hr")}
      </p>
      <p>
        <b>
          {" "}
          {t("ENDS")} {t("AT")} :{" "}
        </b>
        {formatTimeField(rowData.play_ends_at, "12hr")}
      </p>
      <p>
        <b>
          {" "}
          {t("STARTS")} {t("AT")} {t("EXACT")} {t("TIME")} :{" "}
        </b>
        {rowData?.play_on_exact_time === "1" ? t("YES") : t("NO")}
      </p>
      <p>
        <b>
          {t("MEDIA")} {t("LENGTH")} :{" "}
        </b>
        {processSecond(parseInt(rowData?.media_duration))}
      </p>
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper
        placement="top"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a
          onClick={() => {
            onClick && onClick(rowData);
          }}
        >
          {formatTimeField(rowData.play_starts_at, "12hr")}{" "}
          {rowData.play_on_exact_time === "1" && t("*")}
        </a>
      </Whisper>
    </Cell>
  );
};

export default CommercialScheduleItemTimeCell;
